import { useQuery, useReactiveVar } from '@apollo/client'
import { useAuth0 } from '@auth0/auth0-react'
import { GET_COUNTERS_WITH_THREADS } from '@lib/graphql/queries/Shared'
import { organizationIdVar } from '@lib/graphql/variables/organizationId'
import Head from 'next/head'

const HeadTitle = ({ title }: { title: string }) => {
  const { isAuthenticated } = useAuth0()

  const orgId = useReactiveVar(organizationIdVar)

  const { data: counters } = useQuery(GET_COUNTERS_WITH_THREADS, {
    skip: !isAuthenticated || !orgId,
  })

  const totalCount =
    +(counters?.threadCounters?.unread ?? 0) +
    +(counters?.getCounters?.notifications ?? 0)

  return (
    <Head>
      <title>
        {totalCount > 0 ? `(${totalCount}${totalCount > 99 ? '+' : ''})` : null}{' '}
        {title}
      </title>
    </Head>
  )
}

export default HeadTitle
